import React, { useState, useEffect } from "react";
import MIndentTypeActionBar from "./MITActionBar/ActionBar";
import DynamicTable from "../../../components/Table/MTable";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";
import axios from "axios";
import { useSelector } from "react-redux";

const MIndentType = () => {
  // State variables
  const [indentTypes, setIndentTypes] = useState([]);
  const [filteredIndentTypes, setFilteredIndentTypes] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null); // For tracking selected rows
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const apiEndpoint = `${API_BASE_URL}/mIndentType/mindent_types`; // Backend endpoint
  const { role } = useSelector((state) => state.auth);

  // Define table columns
  const columns = [
    { key: "TypeID", label: "ID" },
    { key: "TypeName", label: "Type Name" },
    { key: "Description", label: "Description" },
  ];

  // Fetch data from the server
  const fetchIndentTypes = async () => {
    try {
      const response = await axios.get(apiEndpoint);
      setIndentTypes(response.data);
      setFilteredIndentTypes(response.data); // Initialize filtered data with full data
    } catch (error) {
      console.error("Error fetching indent types:", error);
    }
  };

  // Search functionality
  const handleSearch = (query) => {
    if (!query) {
      setFilteredIndentTypes(indentTypes); // Reset filtered data if query is empty
    } else {
      setFilteredIndentTypes(
        indentTypes.filter((type) =>
          type.TypeName.toLowerCase().includes(query.toLowerCase())
        )
      );
    }
  };

  // Handle saving a new MIndentType
  const handleSave = async (data) => {
    try {
      await axios.post(apiEndpoint, data);
      fetchIndentTypes(); // Refresh data after adding new item
      alert("Item added successfully!");
    } catch (error) {
      console.error("Error adding MIndent Type:", error);
      alert("Failed to add item. Please try again.");
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchIndentTypes();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <Header exportEndpoint={apiEndpoint} />

      {/* Main content */}
      <div className="flex-grow p-4">
        {/* Action Bar */}
        <MIndentTypeActionBar
          title="MIndent Types"
          fields={[
            { name: "TypeName", label: "Type Name", required: true },
            { name: "Description", label: "Description", type: "text" },
          ]}
          apiEndpoint={apiEndpoint}
          data={filteredIndentTypes}
          selectedRow={selectedRow} // Pass selected row for edit/delete
          onRowSelect={setSelectedRow} // Callback to track selected row
          onRefresh={fetchIndentTypes} // Refresh data on action
          onSearch={handleSearch} // Handle search queries
          onSave={handleSave} // Handle save new item
          userRole={role} // Pass the user role
        />

        {/* Table Heading */}
        <div className="mt-6 mb-2 text-center">
          <h3 className="text-xl font-semibold">Indent Types Table</h3>
        </div>

        {/* Dynamic Table */}
        <div className="mt-4">
          <DynamicTable
            columns={columns}
            data={filteredIndentTypes}
            selectedRow={selectedRow} // Highlight selected row
            onRowSelect={setSelectedRow} // Track row selection
            rowKey="TypeID"
            highlightColor="bg-green-100"
            noDataMessage="No units found."
          />
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default MIndentType;
